/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_EmptyInputs */

const en_us2_coach_empty = /** @type {(inputs: Coach_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask anything about your training. The answers are based on scientific studies.`)
};

const pt_br2_coach_empty = /** @type {(inputs: Coach_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pergunte qualquer coisa sobre o seu treino. As respostas se baseiam em estudos científicos.`)
};

const es_419_coach_empty = /** @type {(inputs: Coach_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pregunta lo que quieras sobre tu entrenamiento. Las respuestas se basan en estudios científicos.`)
};

const pt_pt2_coach_empty = /** @type {(inputs: Coach_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pergunta o que quiseres sobre o teu treino. As respostas baseiam-se em estudos científicos.`)
};

const fr_fr2_coach_empty = /** @type {(inputs: Coach_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pose n'importe quelle question sur ton entraînement. Les réponses s'appuient sur des études scientifiques.`)
};

const de_de2_coach_empty = /** @type {(inputs: Coach_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frag alles zu deinem Training. Die Antworten basieren auf wissenschaftlichen Studien.`)
};

const it_it2_coach_empty = /** @type {(inputs: Coach_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiedi qualsiasi cosa sul tuo allenamento. Le risposte si basano su studi scientifici.`)
};

/**
* | output |
* | --- |
* | "Ask anything about your training. The answers are based on scientific studies." |
*
* @param {Coach_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_empty = /** @type {((inputs?: Coach_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_empty(inputs)
	if (locale === "es-419") return es_419_coach_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_empty(inputs)
	if (locale === "de-DE") return de_de2_coach_empty(inputs)
	if (locale === "it-IT") return it_it2_coach_empty(inputs)
	return en_us2_coach_empty(inputs)
});
export { coach_empty as "coach.empty" }